var _path, _circle, _circle2, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRidePickDest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 88,
    viewBox: "0 0 20 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04953 72.0501C6.36235 70.7373 8.14292 69.9998 9.99953 69.9998C11.8561 69.9998 13.6367 70.7373 14.9495 72.0501C16.2624 73.3629 16.9999 75.1435 16.9999 77.0001C16.9999 78.8567 16.2624 80.6373 14.9495 81.9501L9.99953 86.9001L5.04953 81.9501C4.39944 81.3001 3.88376 80.5284 3.53194 79.6791C3.18011 78.8297 2.99902 77.9194 2.99902 77.0001C2.99902 76.0808 3.18011 75.1705 3.53194 74.3212C3.88376 73.4718 4.39944 72.7001 5.04953 72.0501ZM9.99953 79.0001C10.53 79.0001 11.0387 78.7894 11.4137 78.4143C11.7888 78.0393 11.9995 77.5305 11.9995 77.0001C11.9995 76.4697 11.7888 75.961 11.4137 75.5859C11.0387 75.2108 10.53 75.0001 9.99953 75.0001C9.4691 75.0001 8.96039 75.2108 8.58532 75.5859C8.21024 75.961 7.99953 76.4697 7.99953 77.0001C7.99953 77.5305 8.21024 78.0393 8.58532 78.4143C8.96039 78.7894 9.4691 79.0001 9.99953 79.0001Z",
    fill: "#2F80ED"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F2F3F7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99944,
    cy: 9.99993,
    r: 5.71429,
    fill: "#2BB180"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 21.5,
    x2: 10.5,
    y2: 67.5,
    stroke: "#6B7280",
    strokeLinecap: "square",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRidePickDest);
export default __webpack_public_path__ + "static/media/ridePickDest.4f858bb1eeda8b6a03f2c8a12a79b5f5.svg";
export { ForwardRef as ReactComponent };